<template>
  <div id="privacy" class="section">
    <h1 class="title">{{ $t('privacy.title') }}</h1>
    <hr>
    <div class="margin-top-60px has-text-left">
      <div class="margin-bottom-60px">
        <h2 class="title">{{ $t('privacy.1') }}</h2>
        <p>{{ $t('privacy.1_1') }}</p>
      </div>
      <div class="margin-bottom-60px">
        <h2 class="title">{{ $t('privacy.2') }}</h2>
        <p>{{ $t('privacy.2_1') }}</p>
      </div>
      <div class="margin-bottom-60px">
        <h2 class="title">{{ $t('privacy.3') }}</h2>
        <p>{{ $t('privacy.3_1') }}</p>
      </div>
      <div class="margin-bottom-60px">
        <h2 class="title">{{ $t('privacy.4') }}</h2>
        <p>{{ $t('privacy.4_1') }}</p>
      </div>
      <div class="margin-bottom-60px">
        <h2 class="title">{{ $t('privacy.5') }}</h2>
        <p>{{ $t('privacy.5_1') }}</p>
      </div>
      <div class="has-text-centered">
        <p>{{ $t('privacy.6') }}</p>
        <a class="has-text-normal" href="https://hcloud.ltd" target="_blank" rel="noreferrer">HCloud Ltd</a>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from "../app.config.json";
import { useSeoHead } from "@/helpers/seo";

export default {
  name: 'Privacy',
  created() {
    useSeoHead({
      base: '/privacy',
      locale: this.$i18n.locale,
      title: `${this.$t('privacy.title')} | ${appConfig[this.$i18n.locale].title}`,
      description: appConfig[this.$i18n.locale].description.privacy,
    })
  }
}
</script>

<style lang="scss" scoped></style>
